// removed by extract-text-webpack-plugin
module.exports = {"date-input-answers":"MonthYearField__date-input-answers___aDyyG","datePicker":"MonthYearField__datePicker___U1jtF"};